import { useEffect, useState } from "react"
import ShowAccordion from "./showAccordion"
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../../utils/decodeHtml";


const EnergySphere = ({ training }) => {

    const header = training?.header3

    const [accordion, setAccordion] = useState([])



    useEffect(() => {
        if (training?.accordions3?.items) {
            const acc = training.accordions3.items;

            const formattedAccordion = acc.map((item) => {
                const properties = item?.content?.properties;
                return {
                    question: properties?.label ?? "",
                    answer: <DecodeHtml html={properties?.accordionContent?.markup} />,
                    open: false
                };
            });

            setAccordion(formattedAccordion);
        }
    }, [training?.accordions3?.items]);

    return (
        <ShowAccordion title={header} accordion={accordion} setAccordion={setAccordion} />
    )
}
EnergySphere.propTypes = {
    training: PropTypes.any
}
export default EnergySphere